const GOOGLE_ADS_ID = "AW-18278329580";
const PRODUCTION_HOST = "thebatcage.ca";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

/** Loads Google Ads (gtag) only on the live production domain. */
export function loadGoogleAds(): void {
  if (typeof window === "undefined") return;
  if (window.location.hostname !== PRODUCTION_HOST) return;
  if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}"]`)) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  // Match Google's snippet: push `arguments`, not a rest-args array.
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GOOGLE_ADS_ID);
}
